import { Select } from '@mantine/core';
import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import { Link } from 'react-router-dom';
import { Icon, IconName } from 'shared/components/Icon';

import { useInvoiceFormContext } from '../InvoiceForm.context';
import styleIdentifiers from '../InvoiceForm.module.scss';
import type { InvoiceFormSharedProps } from '../InvoiceForm.types';

const styles = classNames.bind(styleIdentifiers);

type BillingLogFieldProps = InvoiceFormSharedProps;

export const BillingLogField = ({ company }: BillingLogFieldProps) => {
  const { t } = useTranslation();
  const form = useInvoiceFormContext();

  const {
    invoice_customization: { billing_logs = [] },
  } = company;

  const data = billing_logs.map((log: { id: string; prefix: string }) => ({
    label: log.prefix,
    value: log.id,
  }));

  const { value, onChange } = form.getInputProps('billing_log_id');

  return (
    <>
      <Select
        data={data}
        value={value != null ? String(value) : null}
        onChange={onChange}
        placeholder={t(i18nKeys.INVOICING.CREATE.BOOK)}
        size="xs"
      />
      {!billing_logs.length && (
        <Link className={styles('link-to-billing')} to="/settings/billing">
          <Icon name={IconName.INFO} /> {t(i18nKeys.FORM.INVOICING.NO_BILLING_LOG)}
        </Link>
      )}
    </>
  );
};
